import EducationsField from './EducationsField.component';

export default EducationsField;
